import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  InputGroup,
  Pagination,
  OverlayTrigger,
  Tooltip,
  Table,
} from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import {
  getAllDelivery_type,
  deleteDelivery_type,
  getCity,
} from "../../../Listfunction";
import LoadingSpinner from "views/Components/loadingSpinner";
import SweetAlert from "react-bootstrap-sweetalert";
import { withRouter } from "react-router";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class viewProductCatalogue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      delivery_type: [],
      cardHidden: true,
      processing: true,

      loading: false,
      alert: null,
      paginationData: [],
      noRecordFound: false,
      nextpage: "",
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      tabledata: "",
      city_info: [],
    };
    this.componentDidMount = this.componentDidMount.bind(this);
    this.paginationinfo = this.paginationinfo.bind(this);
    this.selectedDeliveryType = this.selectedDeliveryType.bind(this);
    this.ConfirmAndCancelMessage = this.ConfirmAndCancelMessage.bind(this);
    this.searchData = this.searchData.bind(this);
  }

  searchData(e) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    getAllDelivery_type(obj).then((response) => {
      var dtype = response.data.data.data;

      for (let i = 0; i < dtype.length; i++) {
        for (let j = 0; j < this.state.city_info.length; j++) {
          if (dtype[i].city_id == this.state.city_info[j].id) {
            dtype[i].city_id = this.state.city_info[j].city_name;
          }
        }
        if (dtype[i].order_type == 1) {
          dtype[i].order_type = "Medicine";
        } else if (dtype[i].order_type == 2) {
          dtype[i].order_type = "Lab Order";
        } else if (dtype[i].order_type == 3) {
          dtype[i].order_type = "Raya";
        }
      }

      this.setState({ delivery_type: dtype });
    });
  }

  datachange() {
    for (let i = 0; i < this.state.delivery_type.length; i++) {
      for (let j = 0; j < this.state.city_info.length; j++) {
        if (this.state.delivery_type[i].city_id == this.state.city_info[j].id) {
          this.state.delivery_type[i].city_id =
            this.state.city_info[j].city_name;
        }
      }
      if (this.state.delivery_type[i].order_type == 1) {
        this.state.delivery_type[i].order_type = "Medicine";
      } else if (this.state.delivery_type[i].order_type == 2) {
        this.state.delivery_type[i].order_type = "Lab Order";
      } else if (this.state.delivery_type[i].order_type == 3) {
        this.state.delivery_type[i].order_type = "Raya";
      }
    }
  }

  ConfirmAndCancelMessage(id) {
    // alert('hi');
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.deleteType(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will not be able to recover this Delivery Type !
        </SweetAlert>
      ),
    });
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  deleteType(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    deleteDelivery_type(id, obj)
      .then(() => {
        this.setState({
          alert: null,
        });
        this.searchData();
      })
      .catch((error) => {
        console.log(error, "== error");
        // this.handleNetworkError("bl", error);
      });
  }

  paginationinfo(url, id) {
    this.setState({
      page: url,
    });
    this.selectstatus(id);
  }

  selectedDeliveryType(cus) {
    // console.log(cus);
    localStorage.setItem("DeliveryTypeID", JSON.stringify(cus));
    this.props.history.push("/admin/editDeliveryType");
  }

  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    await getAllDelivery_type(obj).then((response) => {
      this.setState({ delivery_type: response.data.data.data });
    });

    var country_id = 1;
    await getCity(obj, country_id).then((res) => {
      // console.log(res,'city');
      this.setState({ city_info: res.data });
    });

    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );

    this.datachange();
  }

  addDeliveryType() {
    this.props.history.push("/admin/addDeliveryType");
  }

  render() {
    const edit = <Tooltip id="edit">Edit</Tooltip>;
    const remove = <Tooltip id="remove">Remove</Tooltip>;
    const all_delivery_type = this.state.delivery_type;

    let c = 1;
    return (
      <div className="main-content">
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Col xs={12} sm={12} md={12} lg={12} className="text-right">
                <Button
                  className="fl_mb_web_1 btn-fill fl_mb_1 w_150 "
                  class="btn-color"
                  fill
                  onClick={this.addDeliveryType.bind(this)}
                >
                  Add Delivery Type <i className="fa fa-plus"></i>
                </Button>
                &nbsp;
              </Col>
            </Col>
            <Col md={12}>
              <Card
                content={
                  <React.Fragment>
                    <Row>
                      <Col md={12}>
                        <Table responsive>
                          <thead>
                            <tr>
                              <th>ID</th>
                              <th>Label</th>
                              <th>Value</th>
                              <th>Within</th>
                              <th>Charge</th>
                              <th>City</th>
                              <th>Order Type</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.loading ? (
                              <tr>
                                <td colspan="10">
                                  <LoadingSpinner />
                                </td>
                              </tr>
                            ) : this.state.noRecordFound ? (
                              <tr>
                                <td colspan="10">
                                  <center>No record found</center>
                                </td>
                              </tr>
                            ) : (
                              <React.Fragment>
                                {all_delivery_type.map((cus, i) => (
                                  <tr key={i}>
                                    <td>{cus.delivery_type_id}</td>

                                    <td style={{ textTransform: "capitalize" }}>
                                      {cus.delivery_type_label}
                                    </td>

                                    <td
                                      dangerouslySetInnerHTML={{
                                        __html: cus.delivery_type_value,
                                      }}
                                    ></td>
                                    <td>{cus.delivery_within}</td>
                                    <td>{cus.delivery_charges}</td>
                                    <td>{cus.city_id}</td>
                                    <td>{cus.order_type}</td>

                                    <td className="td-actions">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={edit}
                                      >
                                        <Button
                                          simple
                                          bsStyle="success"
                                          onClick={this.selectedDeliveryType.bind(
                                            this,
                                            cus.id
                                          )}
                                          bsSize="xs"
                                        >
                                          <i className="fa fa-edit" />
                                        </Button>
                                      </OverlayTrigger>

                                      <OverlayTrigger
                                        placement="top"
                                        overlay={remove}
                                      >
                                        <Button
                                          simple
                                          bsStyle="danger"
                                          onClick={this.ConfirmAndCancelMessage.bind(
                                            this,
                                            cus.id
                                          )}
                                          bsSize="xs"
                                        >
                                          <i className="fa fa-times" />
                                        </Button>
                                      </OverlayTrigger>
                                    </td>
                                  </tr>
                                ))}
                              </React.Fragment>
                            )}
                          </tbody>
                        </Table>
                        {this.state.loading ? (
                          ""
                        ) : this.state.noRecordFound ? (
                          ""
                        ) : (
                          <div style={{ textAlign: "center" }}>
                            <Pagination>
                              {!this.state.prevdisabled ? (
                                <Pagination.First
                                  onClick={this.paginationinfo.bind(
                                    this,
                                    this.state.prevpage
                                  )}
                                  disabled={this.state.prevdisabled}
                                />
                              ) : (
                                ""
                              )}
                              {this.state.paginationData.map((url, key) => (
                                <Pagination.Item
                                  key={key}
                                  active={
                                    this.state.currentPage == c ? "1" : null
                                  }
                                  onClick={this.paginationinfo.bind(this, url)}
                                >
                                  {c++}
                                </Pagination.Item>
                              ))}
                              {!this.state.nextdisabled ? (
                                <Pagination.Last
                                  onClick={this.paginationinfo.bind(
                                    this,
                                    this.state.nextpage
                                  )}
                                  disabled={this.state.nextdisabled}
                                />
                              ) : (
                                ""
                              )}
                            </Pagination>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </React.Fragment>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default withRouter(viewProductCatalogue);
